import type { AxiosInstance } from 'axios';

export interface MessageSurvey {
  id: string;
  name: string;
  data: Record<string, unknown>;
  segmentIdentifier: string | null;
  createdOn: string;
  updatedOn: string;
}

export class SurveysClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  getSurveys = async (segmentIdentifier: string): Promise<MessageSurvey[]> => {
    const res = await this.authenticatedClient.get<MessageSurvey[]>('/surveys', {
      params: { segmentIdentifier },
    });
    return res.data;
  };
}
